/* ============================================================
   TRAIL POPUP - CLOSE / LOCAL STORAGE
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector("[data-trail-popup]");

  if (!popup) return;

  const closeButtons = popup.querySelectorAll(
    "[data-trail-popup-close]"
  );

  const viewMoreButton = popup.querySelector(
    "#trialViewMoreBtn"
  );

  const storageKey = "trailPopupClosedUntil";
  const oneHour = 60 * 60 * 1000;

  /*
   * Check if popup was already closed
   * within the last 1 hour.
   */

  const closedUntil = localStorage.getItem(storageKey);

  if (closedUntil && Date.now() < Number(closedUntil)) {
    return;
  }

  /*
   * Show popup
   */

  setTimeout(function () {
    document.body.classList.add(
      "trail-popup-is-active"
    );

    popup.classList.add("is-active");

    popup.setAttribute(
      "aria-hidden",
      "false"
    );
  }, 7000);

  /*
   * Existing close button
   */

  closeButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      document.body.classList.remove(
        "trail-popup-is-active"
      );

      popup.classList.remove("is-active");

      popup.setAttribute(
        "aria-hidden",
        "true"
      );

      /*
       * Save for 1 hour
       */

      localStorage.setItem(
        storageKey,
        Date.now() + oneHour
      );
    });
  });

  /*
   * View More button
   * Same localStorage behavior as close button
   */

  if (viewMoreButton) {
    viewMoreButton.addEventListener("click", function () {
      document.body.classList.remove(
        "trail-popup-is-active"
      );

      popup.classList.remove("is-active");

      popup.setAttribute(
        "aria-hidden",
        "true"
      );

      /*
       * Save for 1 hour
       */

      localStorage.setItem(
        storageKey,
        Date.now() + oneHour
      );
    });
  }
});


/* ============================================================
   TRAIL POPUP VARIANT FUNCTIONALITY
   ============================================================ */

(function () {
  "use strict";

  /* ==========================================================
     TRAIL POPUP ONLY
     ========================================================== */

  const trailPopup = document.querySelector("#TrailPopup");

  if (!trailPopup) return;


  /* ==========================================================
     CONSTANTS
     ========================================================== */

  const ATC_COLOR = "#ED5431";

  const OUT_OF_STOCK_COLOR = "#ADADAD";


  /* ==========================================================
     HELPERS
     ========================================================== */

  const qsa = function (selector, root = trailPopup) {
    return root.querySelectorAll(selector);
  };


  /* ==========================================================
     PARSE PRODUCT VARIANTS
     JSON ID:
     #trailViewJson
     ========================================================== */

  function parseProductVariants(scope = trailPopup) {
    const jsonScript = scope.querySelector("#trailViewJson");

    if (!jsonScript) {
      console.warn(
        "Trail Popup: #trailViewJson not found"
      );

      return [];
    }

    try {
      const text = jsonScript.textContent.trim();

      /*
       * var productVariants = [...]
       */
      const match = text.match(
        /var\s+productVariants\s*=\s*(\[[\s\S]*?\]);/
      );

      if (match && match[1]) {
        return JSON.parse(match[1]);
      }

      /*
       * Plain JSON
       */
      if (
        text.startsWith("[") &&
        text.endsWith("]")
      ) {
        return JSON.parse(text);
      }

    } catch (error) {
      console.error(
        "Trail Popup: Failed to parse variants:",
        error
      );
    }

    return [];
  }


  function parseTrailAvailabilityMap(scope = trailPopup) {
    const jsonScript = scope.querySelector("#trailAvailabilityJson");


    if (!jsonScript) {
      return {};
    }


    try {
      return JSON.parse(
        jsonScript.textContent.trim()
      );
    } catch (error) {
      console.error(
        "Trail Popup: Failed to parse availability map:",
        error
      );
    }


    return {};
  }


  /* ==========================================================
     CHECK VARIANT OPTIONS
     ========================================================== */

  function hasVariantOptions(parent) {
    return !!(
      parent.querySelector(
        ".Size-is-your-option"
      ) ||
      parent.querySelector(
        ".Absorbency-is-your-option"
      ) ||
      parent.querySelector(
        ".Rise-is-your-option"
      )
    );
  }


  /* ==========================================================
     GET OPTION VALUE
     ========================================================== */

  function getOptionValue(element) {
    if (!element) {
      return "";
    }

    return (
      element.dataset.optionValue ||
      element.getAttribute("data-option-value") ||
      element.textContent.trim()
    );
  }


  /* ==========================================================
     FIND MATCHED VARIANT
     ========================================================== */

  function findMatchedVariant(
    variants,
    sizeEl,
    absEl,
    riseEl
  ) {
    if (
      !Array.isArray(variants) ||
      !variants.length
    ) {
      return null;
    }

    const size = getOptionValue(sizeEl);

    const abs = getOptionValue(absEl);

    const rise = getOptionValue(riseEl);

    const hasOption1 = variants.some(function (variant) {
      return variant.option1;
    });

    const hasOption2 = variants.some(function (variant) {
      return variant.option2;
    });

    const hasOption3 = variants.some(function (variant) {
      return variant.option3;
    });


    /*
     * Required options
     */

    if (hasOption1 && !size) {
      return null;
    }

    if (hasOption2 && !abs) {
      return null;
    }

    if (hasOption3 && !rise) {
      return null;
    }


    return (
      variants.find(function (variant) {

        const option1Match =
          !hasOption1 ||
          variant.option1 === size;

        const option2Match =
          !hasOption2 ||
          variant.option2 === abs;

        const option3Match =
          !hasOption3 ||
          variant.option3 === rise;

        return (
          option1Match &&
          option2Match &&
          option3Match
        );
      }) || null
    );
  }


  /* ==========================================================
     PRICE FORMAT
     ========================================================== */

  function formatTrailRupees(cents) {
    return `₹ ${(Number(cents) / 100).toLocaleString("en-IN")}`;
  }


  /* ==========================================================
     DISCOUNT LABEL
     ========================================================== */

  function formatSaveDiscountLabel(
    variantComparePrice,
    variantPrice
  ) {
    const compare =
      Number(variantComparePrice) || 0;

    const price =
      Number(variantPrice) || 0;

    if (compare <= price) {
      return null;
    }

    const discountPercentage =
      Math.round(
        ((compare - price) / compare) * 100
      );

    const saveAmount =
      (compare - price) / 100;

    return `Save ₹ ${saveAmount} <span>(${discountPercentage}% off)</span>`;
  }


  /* ==========================================================
     NORMALIZE AVAILABILITY VALUE
     
     IMPORTANT FIX:
     
     Super Heavy
     SuperHeavy
     super heavy
     SUPER HEAVY
     
     will all become:
     
     superheavy
     ========================================================== */

  function normalizeAvailabilityValue(value) {
    return String(value || "")
      .trim()
      .replace(/\s+/g, "")
      .toLowerCase();
  }


  /* ==========================================================
     AVAILABILITY MAP KEY

     MAP FORMAT:

     XS_Medium_
     XS_Heavy_
     XS_SuperHeavy_

     S_Medium_
     S_Heavy_
     S_SuperHeavy_
     ========================================================== */

  function getTrailAvailabilityKey(
    scope = trailPopup
  ) {
    const sizeEl = scope.querySelector(
      ".Size-is-your-option.active"
    );

    const absEl = scope.querySelector(
      ".Absorbency-is-your-option.active"
    );

    /*
     * We need both Size and Absorbency
     * before checking availability.
     */
    if (!sizeEl || !absEl) {
      return null;
    }

    const size = getOptionValue(sizeEl);

    const absorbency =
      getOptionValue(absEl);

    if (!size || !absorbency) {
      return null;
    }


    /*
     * IMPORTANT FIX
     *
     * Normalize values so:
     *
     * Super Heavy
     * SuperHeavy
     * super heavy
     *
     * all become:
     *
     * superheavy
     */

    const normalizedSize =
      normalizeAvailabilityValue(size);

    const normalizedAbsorbency =
      normalizeAvailabilityValue(absorbency);


    return `${normalizedSize}_${normalizedAbsorbency}_`;
  }


  /* ==========================================================
     CHECK TRAIL AVAILABILITY MAP

     IMPORTANT:
     Handles:

     XS_SuperHeavy_
     XS_superheavy_
     XS_Super Heavy_

     correctly.
     ========================================================== */

  function getTrailAvailability(
    scope = trailPopup
  ) {
    const trailAvailabilityMap =
      parseTrailAvailabilityMap(scope);


    if (
      !Object.keys(
        trailAvailabilityMap
      ).length
    ) {
      return null;
    }


    const key =
      getTrailAvailabilityKey(scope);


    /*
     * No complete selection yet.
     */
    if (!key) {
      return null;
    }


    /*
     * Normalize generated key.
     */
    const normalizedKey =
      key
        .replace(/\s+/g, "")
        .toLowerCase();


    /*
     * Find matching key in availabilityMap.
     */
    const matchedKey =
      Object.keys(trailAvailabilityMap).find(
        function (mapKey) {

          const normalizedMapKey =
            String(mapKey)
              .replace(/\s+/g, "")
              .toLowerCase();

          return (
            normalizedMapKey ===
            normalizedKey
          );
        }
      );


    /*
     * Key doesn't exist.
     *
     * Treat as unavailable.
     */
    if (!matchedKey) {
      console.warn(
        "Trail Popup: Availability key not found:",
        key,
        trailAvailabilityMap
      );

      return false;
    }


    /*
     * Convert true / "true"
     * correctly.
     */
    return (
      trailAvailabilityMap[matchedKey] === true ||
      String(
        trailAvailabilityMap[matchedKey]
      ).toLowerCase() === "true"
    );
  }


  /* ==========================================================
     CLEAR GREY STYLES FROM ALL OPTIONS

     IMPORTANT:

     We clear grey styling from ALL
     Size / Absorbency / Rise options.

     This prevents an old out-of-stock
     option from remaining grey after
     selecting another variant.

     Original CSS colors will return.
     ========================================================== */

  function clearAllOutOfStockStyles(
    scope = trailPopup
  ) {
    const allOptions =
      scope.querySelectorAll(
        ".Size-is-your-option, " +
        ".Absorbency-is-your-option, " +
        ".Rise-is-your-option"
      );

    allOptions.forEach(function (option) {

      option.style.backgroundColor = "";

      option.style.color = "";

      option.style.opacity = "";

      option.style.cursor = "";
    });
  }


  /* ==========================================================
     RESET AVAILABILITY UI
     ========================================================== */

  function resetTrailAvailabilityUI(
    scope = trailPopup
  ) {
    const btn =
      scope.querySelector(
        "#trail-add-to-cart-btn"
      );

    const text =
      scope.querySelector(
        "#trail-add-to-cart-btn #trail-button-text"
      );


    /*
     * Clear grey styling from ALL
     * options.
     */

    clearAllOutOfStockStyles(scope);


    /*
     * Restore button.
     */

    if (btn) {

      btn.removeAttribute("disabled");

      btn.style.backgroundColor =
        ATC_COLOR;

      btn.style.color = "";

      btn.style.cursor = "";
    }


    if (text) {
      text.textContent =
        "Add To Cart";
    }
  }


  /* ==========================================================
     UPDATE AVAILABILITY UI
     ========================================================== */

  function updateTrailAvailability(
    scope = trailPopup
  ) {
    const btn =
      scope.querySelector(
        "#trail-add-to-cart-btn"
      );

    const text =
      scope.querySelector(
        "#trail-add-to-cart-btn #trail-button-text"
      );


    if (!btn) {
      return null;
    }


    /*
     * IMPORTANT FIX
     *
     * Every time user selects another
     * variant, remove ALL previous
     * grey inline styles first.
     *
     * This restores original colors.
     */

    clearAllOutOfStockStyles(scope);


    const sizeEl =
      scope.querySelector(
        ".Size-is-your-option.active"
      );

    const absEl =
      scope.querySelector(
        ".Absorbency-is-your-option.active"
      );


    /*
     * INITIAL STATE
     *
     * If nothing is selected,
     * keep everything normal.
     */

    if (!sizeEl || !absEl) {

      resetTrailAvailabilityUI(scope);

      return null;
    }


    /*
     * Check availabilityMap.
     */

    const isAvailable =
      getTrailAvailability(scope);


    /*
     * availabilityMap doesn't exist.
     */

    if (isAvailable === null) {

      resetTrailAvailabilityUI(scope);

      return null;
    }


    /* ========================================================
       AVAILABLE
       ======================================================== */

    if (isAvailable === true) {

      /*
       * Keep ALL options in their
       * original CSS colors.
       */

      clearAllOutOfStockStyles(scope);


      /*
       * Restore button.
       */

      btn.removeAttribute("disabled");

      btn.style.backgroundColor =
        ATC_COLOR;

      btn.style.color = "";

      btn.style.cursor = "";


      if (text) {
        text.textContent =
          "Add To Cart";
      }

      return true;
    }


    /* ========================================================
       OUT OF STOCK
       ======================================================== */

    /*
     * Grey ONLY currently active
     * options.
     */

    const selectedOptions =
      scope.querySelectorAll(
        ".Size-is-your-option.active, " +
        ".Absorbency-is-your-option.active, " +
        ".Rise-is-your-option.active"
      );


    selectedOptions.forEach(function (option) {

      option.style.backgroundColor =
        OUT_OF_STOCK_COLOR;

      option.style.color = "#fff";

      option.style.opacity = "0.7";

      option.style.cursor =
        "not-allowed";
    });


    /*
     * Disable button.
     */

    btn.setAttribute(
      "disabled",
      "disabled"
    );

    btn.style.backgroundColor =
      OUT_OF_STOCK_COLOR;

    btn.style.color = "#777";

    btn.style.cursor =
      "not-allowed";


    /*
     * Change button text.
     */

    if (text) {
      text.textContent =
        "OUT OF STOCK";
    }


    return false;
  }


  /* ==========================================================
     UPDATE TRAIL PRICING
     ========================================================== */

  function updateTrailPricing(
    parent,
    productVariants
  ) {
    if (!parent) {
      return false;
    }


    const sizeEl =
      parent.querySelector(
        ".Size-is-your-option.active"
      );

    const absEl =
      parent.querySelector(
        ".Absorbency-is-your-option.active"
      );

    const riseEl =
      parent.querySelector(
        ".Rise-is-your-option.active"
      );


    const salePriceEl =
      parent.querySelector(
        "#sale-price"
      );


    let comparePriceEl =
      parent.querySelector(
        "#original-price"
      );


    const discountEl =
      parent.querySelector(
        ".show-price-discount .product-price__item.price-label--sale"
      );


    const productPriceWrap =
      parent.querySelector(
        "#product-price"
      );


    const customVariantInput =
      parent.querySelector(
        ".product_selected_variant_id"
      );


    const atc =
      parent.querySelector(
        "#trail-add-to-cart-btn"
      );


    /*
     * Keep normal state while
     * variant selection is happening.
     */

    if (atc) {
      atc.style.backgroundColor =
        ATC_COLOR;
    }


    /* ========================================================
       NO VARIANT OPTIONS
       ======================================================== */

    if (
      !hasVariantOptions(parent)
    ) {

      const variants =
        Array.isArray(productVariants)
          ? productVariants
          : [];


      const variant =
        variants.find(function (item) {

          return (
            String(item.id) ===
            String(
              customVariantInput?.value
            )
          );

        }) || variants[0];


      if (!variant) {
        return false;
      }


      if (customVariantInput) {

        customVariantInput.value =
          variant.id;
      }


      return true;
    }


    /* ========================================================
       FIND MATCHED VARIANT
       ======================================================== */

    const matchedVariant =
      findMatchedVariant(
        productVariants,
        sizeEl,
        absEl,
        riseEl
      );


    /*
     * No complete variant selected.
     */

    if (!matchedVariant) {

      if (customVariantInput) {
        customVariantInput.value =
          "";
      }


      if (atc) {

        atc.removeAttribute(
          "disabled"
        );

        atc.style.backgroundColor =
          ATC_COLOR;

        atc.style.color = "";

        atc.style.cursor = "";
      }


      /*
       * Clear old grey styles.
       */

      clearAllOutOfStockStyles(
        parent
      );


      return false;
    }


    /* ========================================================
       VARIANT DATA
       ======================================================== */

    const variantPrice =
      Number(
        matchedVariant.price
      ) || 0;


    const variantComparePrice =
      Number(
        matchedVariant.compare_at_price
      ) || 0;


    /* ========================================================
       UPDATE VARIANT INPUT
       ======================================================== */

    if (customVariantInput) {

      customVariantInput.value =
        matchedVariant.id;


      customVariantInput.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    }


    /* ========================================================
       PRICE
       ======================================================== */

    const hasCompare =
      variantComparePrice >
      variantPrice;


    if (salePriceEl) {

      salePriceEl.textContent =
        formatTrailRupees(
          variantPrice
        );


      salePriceEl.setAttribute(
        "item-price",
        variantPrice
      );


      salePriceEl.classList.add(
        "sale-price"
      );


      salePriceEl.classList.toggle(
        "sale-price--discounted",
        hasCompare
      );


      salePriceEl.classList.toggle(
        "sale-price--regular",
        !hasCompare
      );


      salePriceEl.setAttribute(
        "data-discounted",
        hasCompare
          ? "true"
          : "false"
      );
    }


    /* ========================================================
       COMPARE PRICE
       ======================================================== */

    if (hasCompare) {

      const compareTxt =
        formatTrailRupees(
          variantComparePrice
        );


      if (comparePriceEl) {

        comparePriceEl.textContent =
          compareTxt;

        comparePriceEl.style.display =
          "";

        comparePriceEl.setAttribute(
          "item-price",
          variantComparePrice
        );

      } else if (salePriceEl) {

        comparePriceEl =
          document.createElement(
            "span"
          );


        comparePriceEl.id =
          "original-price";


        comparePriceEl.setAttribute(
          "item-price",
          variantComparePrice
        );


        comparePriceEl.textContent =
          compareTxt;


        salePriceEl.insertAdjacentElement(
          "afterend",
          comparePriceEl
        );
      }


      if (discountEl) {

        const discountHtml =
          formatSaveDiscountLabel(
            variantComparePrice,
            variantPrice
          );


        discountEl.innerHTML =
          discountHtml || "";


        discountEl.style.display =
          discountHtml
            ? ""
            : "none";
      }

    } else {

      if (comparePriceEl) {

        comparePriceEl.style.display =
          "none";

        comparePriceEl.textContent =
          "";
      }


      if (discountEl) {

        discountEl.innerHTML =
          "";

        discountEl.style.display =
          "none";
      }
    }


    /* ========================================================
       PRICE WRAPPER
       ======================================================== */

    if (productPriceWrap) {

      productPriceWrap.classList.toggle(
        "shown-compare-price",
        hasCompare
      );
    }


    /* ========================================================
       ATC DATA
       ======================================================== */

    if (atc) {

      atc.setAttribute(
        "data-price",
        variantPrice / 100
      );


      if (matchedVariant.sku) {

        atc.setAttribute(
          "data-sku",
          matchedVariant.sku
        );
      }
    }


    /*
     * Check availability AFTER
     * variant selection.
     */

    return updateTrailAvailability(
      parent
    );
  }


  /* ==========================================================
     VARIANT SELECTION
     ========================================================== */

  function bindTrailVariantSelection(
    scope = trailPopup
  ) {

    /*
     * Prevent duplicate binding.
     */

    if (
      scope.dataset.trailVariantBound ===
      "true"
    ) {
      return;
    }


    scope.dataset.trailVariantBound =
      "true";


    const productVariants =
      parseProductVariants(scope);


    qsa(
      ".Size-is-your-option, " +
      ".Absorbency-is-your-option, " +
      ".Rise-is-your-option",
      scope
    ).forEach(function (element) {

      element.addEventListener(
        "click",
        function (e) {

          e.preventDefault();


          const form =
            this.closest(
              "#trail-product-form"
            );


          if (!form) {
            return;
          }


          /*
           * IMPORTANT:
           *
           * Before selecting another
           * variant, remove ALL grey
           * styles from ALL options.
           */

          clearAllOutOfStockStyles(
            scope
          );


          hideTrailSelectionError(
            scope
          );


          /*
           * Existing class:
           * .new-varaint
           */

          const wrapper =
            this.parentElement;


          if (wrapper) {

            wrapper
              .querySelectorAll(
                ".new-varaint"
              )
              .forEach(function (el) {

                el.classList.remove(
                  "active"
                );
              });
          }


          /*
           * Existing class:
           * .active
           */

          this.classList.add(
            "active"
          );


          /*
           * Update variant and price.
           */

          updateTrailPricing(
            form,
            productVariants
          );
        }
      );
    });
  }


  /* ==========================================================
     ADD TO CART BUTTON

     Same AJAX flow as quickview:
     - Validate selected options
     - Add selected variant with selected quantity
     - Open Shopflo cart handler after add
     ========================================================== */

  function closeTrailPopupAfterAdd() {
    document.body.classList.remove(
      "trail-popup-is-active"
    );


    trailPopup.classList.remove(
      "is-active"
    );


    trailPopup.setAttribute(
      "aria-hidden",
      "true"
    );


    const storageKey =
      "trailPopupClosedUntil";


    const oneHour =
      60 *
      60 *
      1000;


    localStorage.setItem(
      storageKey,
      Date.now() + oneHour
    );
  }


  function getTrailQuantity(scope = trailPopup) {
    const qtyInput =
      scope.querySelector(
        'input[name="quant[1]"]'
      );


    const mirrorInput =
      scope.querySelector(
        "#mahina_quantity"
      );


    const rawQuantity =
      qtyInput?.value ||
      mirrorInput?.value ||
      "1";


    const quantity =
      parseInt(
        rawQuantity,
        10
      );


    return Math.max(
      1,
      Number.isNaN(quantity)
        ? 1
        : quantity
    );
  }


  function setTrailQuantity(
    quantity,
    scope = trailPopup
  ) {
    const qtyInput =
      scope.querySelector(
        'input[name="quant[1]"]'
      );


    const mirrorInput =
      scope.querySelector(
        "#mahina_quantity"
      );


    if (qtyInput) {
      qtyInput.value =
        quantity;
    }


    if (mirrorInput) {
      mirrorInput.value =
        quantity;
    }
  }


  function bindTrailQuantityButtons(
    scope = trailPopup
  ) {
    if (
      scope.dataset.trailQtyBound ===
      "true"
    ) {
      return;
    }


    scope.dataset.trailQtyBound =
      "true";


    qsa(
      ".btnnumber",
      scope
    ).forEach(function (button) {
      button.addEventListener(
        "click",
        function (event) {
          /*
           * Capture + stopImmediatePropagation
           * so mahina.js (and other global
           * .btnnumber handlers) do not also
           * change quantity (+/- 2).
           */
          event.preventDefault();
          event.stopPropagation();

          if (
            typeof event.stopImmediatePropagation ===
            "function"
          ) {
            event.stopImmediatePropagation();
          }


          const input =
            scope.querySelector(
              `input[name="${this.dataset.field}"]`
            );


          if (!input) {
            return;
          }


          const current =
            parseInt(
              input.value,
              10
            ) || 1;


          const min =
            parseInt(
              input.min,
              10
            ) || 1;


          const max =
            parseInt(
              input.max,
              10
            ) || 10;


          let nextQuantity =
            current;


          if (
            this.dataset.type ===
            "plus"
          ) {
            nextQuantity =
              Math.min(
                current + 1,
                max
              );
          }


          if (
            this.dataset.type ===
            "minus"
          ) {
            nextQuantity =
              Math.max(
                current - 1,
                min
              );
          }


          setTrailQuantity(
            nextQuantity,
            scope
          );
        },
        true
      );
    });
  }


  function showTrailSelectionError(
    scope,
    message
  ) {
    const errEl =
      scope.querySelector(
        ".selection-error-msg"
      );


    if (!errEl) {
      return;
    }


    errEl.textContent =
      message;


    errEl.classList.add(
      "show"
    );
  }


  function hideTrailSelectionError(
    scope
  ) {
    const errEl =
      scope.querySelector(
        ".selection-error-msg"
      );


    if (errEl) {
      errEl.classList.remove(
        "show"
      );
    }
  }


  function getTrailSelectionErrorMessage(
    scope
  ) {
    const missing = [];


    if (
      scope.querySelector(
        ".Size-is-your-option"
      ) &&
      !scope.querySelector(
        ".Size-is-your-option.active"
      )
    ) {
      missing.push(
        "size"
      );
    }


    if (
      scope.querySelector(
        ".Absorbency-is-your-option"
      ) &&
      !scope.querySelector(
        ".Absorbency-is-your-option.active"
      )
    ) {
      missing.push(
        "absorbency"
      );
    }


    if (
      scope.querySelector(
        ".Rise-is-your-option"
      ) &&
      !scope.querySelector(
        ".Rise-is-your-option.active"
      )
    ) {
      missing.push(
        "rise"
      );
    }


    if (!missing.length) {
      return "";
    }


    if (missing.length === 1) {
      return `Please select ${missing[0]}`;
    }


    const last =
      missing.pop();


    return `Please select ${missing.join(
      ", "
    )} & ${last}`;
  }


  function setupAddToCartButton(
    scope = trailPopup
  ) {

    const atc =
      scope.querySelector(
        "#trail-add-to-cart-btn"
      );


    if (!atc) {
      return;
    }


    /*
     * Prevent duplicate binding.
     */

    if (
      atc.dataset.trailAtcBound ===
      "true"
    ) {
      return;
    }


    atc.dataset.trailAtcBound =
      "true";


    /*
     * Initial state:
     * normal button.
     */

    atc.removeAttribute(
      "disabled"
    );


    atc.style.backgroundColor =
      ATC_COLOR;


    const form =
      scope.querySelector(
        "#trail-product-form"
      );


    if (!form) {
      return;
    }


    /*
     * Trail popup ATC always uses
     * Ajax Cart API and passes
     * Trial_ATC on every page.
     *
     * Bound on button click (capture)
     * so Shopflo / other ATC hooks
     * cannot add without the property.
     */

    atc.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();


        if (
          typeof event.stopImmediatePropagation ===
          "function"
        ) {
          event.stopImmediatePropagation();
        }


        const buttonText =
          atc.querySelector(
            "#trail-button-text"
          );


        const productVariants =
          parseProductVariants(scope);


        const sizeEl =
          scope.querySelector(
            ".Size-is-your-option.active"
          );


        const absEl =
          scope.querySelector(
            ".Absorbency-is-your-option.active"
          );


        const riseEl =
          scope.querySelector(
            ".Rise-is-your-option.active"
          );


        const selectionError =
          getTrailSelectionErrorMessage(
            scope
          );


        if (selectionError) {
          showTrailSelectionError(
            scope,
            selectionError
          );

          return;
        }


        const matchedVariant =
          hasVariantOptions(scope)
            ? findMatchedVariant(
                productVariants,
                sizeEl,
                absEl,
                riseEl
              )
            : null;


        if (
          hasVariantOptions(scope) &&
          !matchedVariant
        ) {
          showTrailSelectionError(
            scope,
            "Selected variant is unavailable"
          );

          return;
        }


        if (
          hasVariantOptions(scope)
        ) {
          const isAvailable =
            updateTrailAvailability(
              scope
            );


          if (
            isAvailable !== true
          ) {
            showTrailSelectionError(
              scope,
              "Selected variant is out of stock"
            );

            return;
          }
        }


        hideTrailSelectionError(
          scope
        );


        const variantInput =
          scope.querySelector(
            ".product_selected_variant_id"
          );


        let variantId =
          variantInput?.value;


        if (
          matchedVariant
        ) {
          variantId =
            matchedVariant.id;


          if (variantInput) {
            variantInput.value =
              variantId;
          }
        }


        if (
          !variantId &&
          productVariants.length === 1
        ) {
          variantId =
            productVariants[0].id;


          if (variantInput) {
            variantInput.value =
              variantId;
          }
        }


        if (!variantId) {
          showTrailSelectionError(
            scope,
            "Variant not selected"
          );

          return;
        }


        const quantity =
          getTrailQuantity(scope);


        atc.setAttribute(
          "disabled",
          "disabled"
        );


        if (buttonText) {
          buttonText.textContent =
            "Adding...";
        }


        fetch(
          "/cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: quantity,
                  properties: {
                    Trial_ATC: "true"
                  }
                }
              ]
            })
          }
        )
          .then(function (response) {
            return response.json().then(
              function (json) {
                if (!response.ok) {
                  throw json;
                }


                return json;
              }
            );
          })
          .then(function () {
            if (buttonText) {
              buttonText.textContent =
                "Added";
            }


            setTimeout(function () {
              if (
                typeof handleFloCartBtn ===
                "function"
              ) {
                handleFloCartBtn();
              }
            }, 500);


            setTimeout(function () {
              closeTrailPopupAfterAdd();
            }, 1200);
          })
          .catch(function (error) {
            const message =
              error?.description ||
              error?.message ||
              "Could not add this product. Please try again.";


            showTrailSelectionError(
              scope,
              message
            );


            console.error(
              "Trail Popup add to cart:",
              error
            );
          })
          .finally(function () {
            atc.removeAttribute(
              "disabled"
            );


            if (buttonText) {
              setTimeout(function () {
                buttonText.textContent =
                  "Add To Cart";
              }, 1800);
            }
          });
      },
      true
    );
  }


  /* ==========================================================
     AVAILABILITY
     ========================================================== */

  function itemAvailabilty(
    scope = trailPopup
  ) {
    return updateTrailAvailability(
      scope
    );
  }


  /* ==========================================================
     INITIALIZE
     ========================================================== */

  function initTrailPopup() {

    const form =
      trailPopup.querySelector(
        "#trail-product-form"
      );


    if (!form) {

      console.warn(
        "Trail Popup: #trail-product-form not found"
      );

      return;
    }


    /* ========================================================
       PARSE VARIANTS
       ======================================================== */

    const variants =
      parseProductVariants(
        trailPopup
      );


    /* ========================================================
       INITIAL PRICE
       ======================================================== */

    updateTrailPricing(
      form,
      variants
    );


    /* ========================================================
       VARIANT SELECTION
       ======================================================== */

    bindTrailVariantSelection(
      trailPopup
    );


    /* ========================================================
       ADD TO CART
       ======================================================== */

    setupAddToCartButton(
      trailPopup
    );


    /* ========================================================
       QUANTITY
       ======================================================== */

    bindTrailQuantityButtons(
      trailPopup
    );


    /*
     * Keep initial state NORMAL.
     */

    const initialButton =
      trailPopup.querySelector(
        "#trail-add-to-cart-btn"
      );


    const initialButtonText =
      trailPopup.querySelector(
        "#trail-add-to-cart-btn #trail-button-text"
      );


    if (initialButton) {

      initialButton.removeAttribute(
        "disabled"
      );


      initialButton.style.backgroundColor =
        ATC_COLOR;


      initialButton.style.color = "";

      initialButton.style.cursor = "";
    }


    if (initialButtonText) {

      initialButtonText.textContent =
        "Add To Cart";
    }
  }


  /* ==========================================================
     INIT
     ========================================================== */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initTrailPopup,
      {
        once: true
      }
    );

  } else {

    initTrailPopup();
  }

})();
